module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-patientform page-inner"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', {
    staticClass: "form_patient"
  }, [_c('Header'), _c('div', {
    staticClass: "service-inner inner-container"
  }, [_c('div', {
    staticClass: "patient-section"
  }, [(_vm.props) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.title)
    }
  }) : _vm._e(), _c('hr'), (_vm.props) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.description)
    }
  }) : _vm._e(), (_vm.props.acf.testimonial_list) ? _c('div', {
    staticClass: "testimonial-slider"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption1
    }
  }, [_vm._l((_vm.props.acf.testimonial_list), function(testimonialList, index) {
    return _c('swiper-slide', [_c('div', {
      staticClass: "testimonial-slide_inner"
    }, [(_vm.props.acf.testimonial_star) ? _c('img', {
      staticClass: "testimonial-star",
      attrs: {
        "src": _vm.props.acf.testimonial_star
      }
    }) : _vm._e(), (testimonialList.description) ? _c('p', {
      staticClass: "testimonial-slide_content",
      domProps: {
        "innerHTML": _vm._s(testimonialList.description)
      }
    }) : _vm._e(), (testimonialList.author) ? _c('p', {
      staticClass: "testimonial-author",
      domProps: {
        "innerHTML": _vm._s(testimonialList.author)
      }
    }) : _vm._e()])])
  }), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 2)], 1) : _vm._e(), _c('div', {
    staticClass: "yelp-reviews"
  }, _vm._l((_vm.props.acf.yelp_list), function(YelpList) {
    return (_vm.props.acf.yelp_list) ? _c('div', {
      staticClass: "yelp-list"
    }, [_c('iframe', {
      staticClass: "yelp-review",
      attrs: {
        "src": YelpList.iframe,
        "scrolling": "yes"
      }
    })]) : _vm._e()
  }))])]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ec23568","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/reviews/reviews.pug
// module id = 542
// module chunks = 1